import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCrossSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"medical-cross-square, first-aid, emergency"} maskId="square-filled-radius-0-stroke-1-IconMedicalCrossSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.5 10.5H8V13.5H10.5V16H13.5V13.5H16V10.5H13.5V8H10.5V10.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMedicalCrossSquare;
